import { auth } from "./firebase";


// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export function doSignInWithEmailAndPassword(email, password, callback) {
  auth
    .signInWithEmailAndPassword(email, password)
    .then((result) => {
      if (callback) callback(result.user.uid);
    })
    .catch((error) => {
      console.error("login error", error);
      if (callback) callback({error: error, status: "error"});
    });
}

// Sign out
export const doSignOut = () => auth.signOut();

// Password Reset
export function doPasswordReset(email, callback) {
  auth
    .sendPasswordResetEmail(email)
    .then((result) => {
      if (callback) callback(result);
    })
    .catch((error) => {
      if (callback) callback({error: error, status: "error"});
    });
}

// Password Change
export const doPasswordUpdate = (password) =>
  auth.currentUser.updatePassword(password);
